import React, { useContext, useState } from 'react';
import { OverlayTrigger, Popover, Modal, Button } from 'react-bootstrap';
import GaugeSettings from "./GaugeSettings";
import PermissionsSettings from "../PermissionsSettings";
import { ConfigContext } from './Gauge';
import YouTubeVideo from '../YouTubeVideo';
import { useTranslation } from 'react-i18next';

function GaugeSettingsContainer(props) {
    const { t } = useTranslation();
    const [showSettings, setShowSettings] = useState(false);
    const [showHelpmodal, setHelpModal] = useState(false);
    const { config } = useContext(ConfigContext);

    function handleClose() {
        setHelpModal(false)
    }

    return (
        props.ready ?
            <>
                <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    show={showSettings}
                    overlay={
                        <Popover style={{ "maxWidth": "85vw", zIndex: 1020 }}>
                            <Popover.Header as="h3" style={{ minHeight: '50px' }}>
                                <span>
                                    {t("components.insights.gaugesettingscontainer.title")}
                                </span>
                                <Button variant="secondary" size="sm" className="ms-2" style={{ float: 'right' }} onClick={() => setHelpModal(true)}>
                                    {t("common.help")} <i class="fas fa-question-circle"></i>
                                </Button>
                                <PermissionsSettings accessControlID={config.AccessControlID} siteGUID={config.SiteGUID} />
                            </Popover.Header>
                            <Popover.Body>
                                <div style={{
                                    minHeight: "150px",
                                    display: "flex",
                                    "justifyContent": "center",
                                    "alignItems": "center",
                                    "flexDirection": "column"
                                }}>
                                    <GaugeSettings
                                        {...props}
                                        hideSettings={() => setShowSettings(false)}
                                    />
                                </div>
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <Button
                        title={t("components.insights.gaugesettingscontainer.title")}
                        onClick={() => setShowSettings(!showSettings)}
                        variant="primary"
                        style={{ marginLeft: 'auto' }}
                    >
                        <i style={{ color: "rgb(255, 255, 255)" }} className="fal fa-cog"></i>
                    </Button>
                </OverlayTrigger>
                <Modal show={showHelpmodal} onHide={handleClose} size="lg" centered>
                    <Modal.Header closeButton>
                        <h5 className="modal-title" id="exampleModalLongTitle">{t("common.help")}</h5>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <YouTubeVideo VideoTag="Gauges" />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("common.close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
            :
            <></>
    );
}

export default GaugeSettingsContainer;